import { format } from 'date-fns';
import type { ColorVariant } from './certification-details.types';
const pillColorByState: Record<string, ColorVariant> = {
  in_progress: 'blue',
  completed: 'green'
};
export const getPillColor = (state: string): ColorVariant => pillColorByState[state] ?? 'orange';
export const formatDate = (dateString: string | undefined) => {
  if (!dateString) return '-';
  try {
    return format(new Date(dateString), 'MMMM d, yyyy h:mm a');
  } catch (error) {
    return '-';
  }
};